<template>
  <v-row>
    <v-col>
      <v-row class="px-2 pt-2">
        <v-col>
          <v-expansion-panels>
            <v-expansion-panel v-test="{ panel: '' }">
              <v-expansion-panel-header>
                <div id="search">
                  <v-icon>
                    search
                  </v-icon>
                  {{ $t('Фильтры') }}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager @keydown.native.enter="focusOnBtn('searchBtn')">
                <v-row class="px-3 py-0 my-0">
                  <v-col
                      class="pt-1 pb-0 my-0"
                      cols="12"
                      sm="10"
                      md="5"
                      lg="4"
                      xl="3">
                    <multiple-date-input
                        v-model="params.tradeBeginDates"
                        :label="$t('Дата начала торгов')" />
                  </v-col>
                  <v-col
                      class="py-0 my-0"
                      cols="12"
                      sm="10"
                      md="5"
                      lg="4"
                      xl="3">
                    <validatable-enum-combobox
                        v-model="params.lotType"
                        v-test="{ combobox: 'lotType' }"
                        clearable
                        :readonly="isLoading"
                        :values-enum="LOT_TYPE_ENUM"
                        :label="$t('Тип торговой процедуры')"
                        @change="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col
                      class="pt-0 pb-6 my-0"
                      cols="12"
                      sm="10"
                      md="5"
                      lg="4"
                      xl="3">
                    <validatable-text-input
                        v-model="params.lotNumber"
                        v-test="{ input: 'lotNumber' }"
                        rules="numeric"
                        :label="$t('№ торговой процедуры')"
                        hide-details
                        @keydown.native.enter="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col
                      class="py-0 my-0"
                      cols="12"
                      sm="10"
                      md="5"
                      lg="4"
                      xl="3">
                    <multiple-string-input
                        v-model="params.lotNames"
                        v-test="{ input: 'lotNames' }"
                        :label="$t('Наименование товара/услуги')" />
                  </v-col>
                  <v-col
                      class="py-0 my-0"
                      cols="12"
                      sm="10"
                      md="5"
                      lg="4"
                      xl="3">
                    <multiple-string-input
                        v-model="params.organizerNames"
                        v-test="{ input: 'organizerNames' }"
                        :label="$t('Организатор')" />
                  </v-col>
                  <v-col
                      v-if="lotStatus === LOT_STATUSES.FINISHED"
                      class="py-0 my-0"
                      cols="12">
                    <v-row>
                      <v-col>
                        <validatable-enum-combobox
                            v-model="params.tradeResultType"
                            v-test="{ combobox: 'tradeResultType' }"
                            clearable
                            :readonly="isLoading"
                            :values-enum="TRADE_RESULT_TYPE_FILTER_ENUM"
                            :label="$t('Результат торгов')" />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="text-right" align-self="center">
                    <btn-icon-tip
                        id="search"
                        ref="searchBtn"
                        icon="search"
                        icon-color="primary"
                        :tip="$t('Поиск')"
                        @click="search" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <paginated-data-table
              v-if="getLotsList"
              ref="paginatedTable"
              :headers="headers1"
              :items="lots"
              :loading="isLoading"
              item-key="lotId"
              :total-count="totalCount"
              :items-per-page="itemsPerPage"
              single-expand
              show-expand
              :request-method="getLotsList">

            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.lotNumber="{ item }">
              {{ item.lotNumber }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.startSessionDate="{ item }">
              {{ item.startSessionDate
                ? $moment(item.startSessionDate).format('DD.MM.YYYY HH:mm')
                : null }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.lotDescription="{ item }">
              <route-link-with-tip
                  :text="item.lotDescription"
                  :tip="$t('Просмотр торговой процедуры')"
                  :to="{ path: `${urlRootPath}/lot/${item.lotType}/${item.lotId}` }" />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.lotType="{ item }">
              {{ $t(LOT_TYPE_ENUM[item.lotType]) }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <!-- <template v-slot:item.productSection.value="{ item }">
              {{ item.productSection.value }}
            </template> -->
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-row class="my-1">
                  <v-col class="text-left">
                    <date-view
                        :display="item.publicationDate"
                        :label="$t('Опубликовано')"
                        date-format="DD.MM.YYYY HH:mm" />
                    <date-view
                        :display="item.endSessionDateWithProlongation"
                        :label="$t('Дата завершения торговой сессии')"
                        date-format="DD.MM.YYYY HH:mm" />
                    <text-view
                        :display="item.organizer
                          ? item.organizer.organizationName
                          : null"
                        :label="$t('Организатор')" />
                    <text-view
                        v-if="!!item.clientOrganizationInn"
                        :display="`${item.clientOrganizationFullName} (${item.clientOrganizationInn})`"
                        :label="$t('Клиент')" />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row class="text-left my-1">
                  <lot-actions
                      :key="item.lotId"
                      :lot-id="item.lotId"
                      :lot-number="item.lotNumber"
                      :lot-status="lotStatus"
                      :lot-type="item.lotType"
                      :privacy-type="privacyType"
                      :summarizing="summarizing"
                      :edited="$refs.paginatedTable.getDataFromServer" />
                </v-row>
              </td>
            </template>
          </paginated-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import PaginatedDataTable from '@/components/reused/ui/PaginatedDataTable.vue'
  import DateView from '@/components/reused/ui/DateView.vue'
  import RouteLinkWithTip from '@/components/reused/ui/RouteLinkWithTip.vue'
  import ValidatableEnumCombobox from '@/components/reused/ui/ValidatableEnumCombobox.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import MultipleDateInput from '@/components/reused/ui/MultipleDateInput.vue'
  import MultipleStringInput from '@/components/reused/ui/MultipleStringInput.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import LotActions from './LotActions.vue'
  import { LOT_TYPE_ENUM, TRADE_RESULT_TYPE_FILTER_ENUM, SET_UNSET_ENUM } from '@/constants/enums'
  import { LOT_STATUSES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { LOTS } from '@/constants/store.js'

  export default {
    components: {
      PaginatedDataTable,
      DateView,
      TextView,
      ValidatableEnumCombobox,
      ValidatableTextInput,
      MultipleDateInput,
      MultipleStringInput,
      RouteLinkWithTip,
      BtnIconTip,
      LotActions
    },
    props: {
      lotStatus: {
        type: String,
        required: true
      },
      privacyType: {
        type: String,
        required: true
      },
      summarizing: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false,
        LOT_TYPE_ENUM,
        LOT_STATUSES,
        TRADE_RESULT_TYPE_FILTER_ENUM,
        SET_UNSET_ENUM,
        itemsPerPage: 10,
        params: {
          summarizing: this.summarizing,
          lotNumber: '',
          lotType: '',
          tradeResultType: null,
          lotNames: [],
          tradeBeginDates: [],
          organizerNames: []
        }
      }
    },
    computed: {
      ...mapState(LOTS.NAMESPACE, {
        lotsInfo: state => lotStatus => (state[LOTS.STATE.LIST][lotStatus] || {})
      }),
      headers1 () {
        return [
          { text: this.$t('№ торговой процедуры'), align: 'start', sortable: true, value: 'lotNumber' },
          { text: this.$t('Дата торгов'), align: 'start', sortable: true, value: 'startSessionDate' },
          { text: this.$t('Торговая процедура'), align: 'start', sortable: true, value: 'lotDescription' },
          { text: this.$t('Форма проведения торгов'), align: 'start', sortable: false, value: 'lotType' },
          { text: '', value: 'data-table-expand' }
        ]
      },
      totalCount () {
        return this.lotsInfo(this.lotStatus).totalCount || 0
      },
      lots () {
        return this.lotsInfo(this.lotStatus).items || []
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOTS.NAMESPACE, {
        getLotsListAction: LOTS.ACTIONS.GET_LOTS_LIST,
        clearLotsListAction: LOTS.ACTIONS.CLEAR_LOTS_LIST
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearLotsListAction(this.lotStatus)
          ])
      },
      search: async function () {
        await this.$refs.paginatedTable.resetPaginationAndGetDataFromServer()
      },
      getLotsList: async function (params) {
        try {
          this.isLoading = true
          await this.getLotsListAction({
            privacyType: this.privacyType,
            lotStatus: this.lotStatus,
            params: {
              ...this.params,
              ...params
            }
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
